<template>
  <div class="common-rowUnder" @scroll="handleScroll" :style="{
        height: 'calc(100vh - 61px)',
        overflowY: 'auto',
        background: '#fff',
    }">

    <div class="choose-cus" v-if="step == 2">
      <div class="common-flex quick-order-details">
        <!-- 用户信息或者工艺品类 -->
        <div class="quick-order-l common-rowUnder">
          <!-- 用户信息 -->
          <div class="order-l-item common-flex common-align-center">
            <div class="order-l-item-label">Name</div>
            <AutoComplete class="order-l-item-ipt" v-model="submitOrder.customerName" @on-select="changeCus"
                          @on-search="handleSearch" style="width: 200px" clearable>
              <Option v-for="item in customer" :value="item.custName" :key="item.id">{{ item.custName }}
              </Option>
            </AutoComplete>
          </div>
          <div class="order-l-item common-flex common-align-center common-justify-between">
            <div class="common-flex common-align-center">
              <div class="order-l-item-label">Height</div>
              <Input class="order-l-item-ipt" type="text" v-model="submitOrder.height" placeholder=""/>
            </div>
            <Select @on-change="changeHeight" label-in-value v-model="submitOrder.heightUnit"
                    style="width: 70px">
              <Option v-for="item in heightList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="order-l-item common-flex common-align-center common-justify-between">
            <div class="common-flex common-align-center">
              <div class="order-l-item-label">Weight</div>
              <Input class="order-l-item-ipt" type="text" v-model="submitOrder.weight" placeholder=""/>
            </div>
            <Select v-model="submitOrder.weightUnit" style="width: 70px">
              <Option v-for="item in weightList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="order-l-item common-flex common-align-center common-justify-between">
            <div class="common-flex common-align-center">
              <div class="order-l-item-label">Gender</div>
            </div>
            <Select class="" v-model="submitOrder.genderId" placeholder="">
              <Option v-for="item in genderList" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
          </div>
          <div class="order-l-item common-flex common-align-center">
            <div class="order-l-item-label">Qty</div>
            <Input class="order-l-item-ipt" type="text" v-model="submitOrder.amount" placeholder=""/>
          </div>
        </div>
        <!-- 品类详情 或者用户具体信息 -->
        <div class="quick-order-r">
          <div class="quick-order-r">
            <div class="order-r-optional order-r-box">Optional</div>
            <div class="common-flex order-r-box">
              <div class="order-r-title">Order #</div>
              <Input class="order-r-ipt" v-model="submitOrder.cusOrderCode"></Input>
            </div>
            <div class="common-flex order-r-box">
              <div class="order-r-title">Phone #</div>
              <Input class="order-r-ipt" v-model="submitOrder.phone"></Input>
            </div>
            <div class="common-flex order-r-box">
              <div class="order-r-title">Email</div>
              <Input class="order-r-ipt" v-model="submitOrder.email"></Input>
            </div>
          </div>
        </div>
      </div>
      <div class="common-flex common-flex-end">
        <div class="common-flex choose-cus-btn">
          <div class="btn-back" @click="back">Back</div>
          <div class="btn-next" @click="next">Next</div>
        </div>
      </div>
    </div>
    <div class="choose-cus select-size" v-if="step == 3">
      <!-- 顶部信息 -->
      <div class="common-flex">
        <div class="quick-order-ll-box"
             :style="[specBodyParams.sizeType == 10054 ? {} : { width: '430px', marginRight: '20px' }]">
          <!-- <div class="quick-order-ll" :style="[specBodyParams.sizeType == 10054 ? {} : { width: '450px'}]"> -->
          <div class="quick-order-ll" :style="[specBodyParams.sizeType == 10054 ? {} : { width: '443px', height: 'calc(100vh - 80px)', overflowY: 'auto', overflowX: 'hidden' }, specBodyParams.sizeType != 10054 && isFixed ? {
        position: 'fixed',
        top: '60px',
    }
        : {}]">
            <div class="common-flex">
              <div style="text-align: left">
                <!-- <div class="title">{{ $t("newOrder.tailored") }}</div> -->
                <Select v-model="specBodyParams.sizeType" @on-change="changeTailored"
                        :placeholder="$t('newOrder.placeholder')" style="width: 425px; margin: 10px 0">
                  <Option v-for="item in tailoredList" :value="item.id" :key="item.id">{{ item.name }}
                  </Option>
                </Select>
              </div>
            </div>
            <!-- ;量体信息 -->
            <div class="measurements">
              <!-- {{ clothing }} -->
              <rMeasurements :preSubmitShow="preSubmitShow" @preSubmit="preSubmit" :standardChooseParent="standardChoose"
                             @measureInfo="measureInfo" @changeSizeId="changeSizeId" @changeStandard="changeStandard"
                             @changeEditOnce="changeEditOnce" :garmentSize="garmentSize" :unit="customerDetails"
                             :standardList="standardList" :sizeTypeId="specBodyParams.sizeType" :clothing="clothing"
                             :editOnce="editOnce" :categoryMessage="categoryMessage"></rMeasurements>
            </div>
          </div>
        </div>
        <div class="quick-order-r common-rowUnder"
             v-if="styleList.length > 0 && specBodyParams.sizeType != 10054">
          <!-- 特体信息 -->
          <div class="dress-style-title" style="text-align: left;">
            {{ $t("newOrder.bodyPosture") }}
          </div>
          <div class="common-flex" style="padding-bottom: 50px">
            <rDressStyle :listWidth="760" :styleList="styleList" @changeStyle="changeStyle"></rDressStyle>
          </div>
        </div>
      </div>
      <div class="common-flex common-flex-end">
        <div class="common-flex choose-cus-btn">
          <div class="btn-back" @click="back">Back</div>
          <div class="btn-next" @click="submit">Save To Cart</div>
          <div class="btn-next" @click="submit('order')">Submit</div>
        </div>
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import {cmToInch, inchToCom} from "../../libs/util";
import rMeasurements from "../../components/r-measurements-quick";
import rDressStyle from "../../components/r-dress-style-quick";

export default {
  data() {
    return {
      spinShow: false,
      isFixed: false,
      // 是否是编辑初次进入
      editOnce: false,
      categoryMessage: "",
      // 是否成功请求预提交接口
      isPreSubmit: false,
      garmentSize: [], //成衣尺寸
      changeCusNum: 0,
      customer: [],
      customerDetails: "", //客户详情
      genderList: [],
      weightList: [],
      heightList: [],
      tailoredList: [], //量体方式
      shapeCategory: "",
      detailList: {
        clothCategory: 0, //服装分类id
        // craftMap: {
        //工艺信息
        // description: "",
        // },
        craftList: [],
        contrastSaveList: [
          // {
          //   color:'',//颜色id 位置id
          //   site:''
          // }
        ], //撞色信息
        embList: [
          //刺绣信息
          // {
          //   color: "", //颜色
          //   embContent: "", //内容
          //   embSize: "", //绣字大小id
          //   font: "", //字体id
          //   site: "", //位置id
          // },
        ],
        shape: "", //号型
        sizeList: [
          //尺寸信息
          {
            // modifyValue: 0, //调整值id
            // partId: 0, //尺寸部位id
            // partValue: 0, //尺寸值id
          },
        ],
        styleId: "", //着装风格id
      },
      submitOrder: {
        onlySize: 1,
        inventory: "",
        custInfo: "",
        fabric: "", //面料编码
        detailList: [
          //订单明细
          {
            clothCategory: 0, //服装分类id
            // craftMap: {
            //工艺信息
            // description: "",
            // },
            craftList: [],
            embList: [
              //刺绣信息
              // {
              //   color: "", //颜色
              //   embContent: "", //内容
              //   embSize: "", //绣字大小id
              //   font: "", //字体id
              //   site: "", //位置id
              //   file: "",
              // },
            ],
            sizeList: [
              //尺寸信息
              {
                modifyValue: 0, //调整值id
                partId: 0, //尺寸部位id
                partValue: 0, //尺寸值id
              },
            ],
            styleId: 0, //着装风格id
          },
        ],
        bodyTypeList: [], //特体
        addProduct: 0, //追加产品 1是 0否
        amount: 1, //数量
        clothCategory: 0, //服装分类id
        //** 地址信息----------*/
        customerName: "", //客户名称
        shortName: "", //昵称
        genderId: "", //性别
        height: "", //身高
        heightUnit: "", //身高单位
        weight: "", //体重
        weightUnit: "", //体重单位
        phone: "", //手机号
        email: "", //邮箱
        address: "", //地址
        birthdate: "", //birthdate
        customerId: "", //客户id //选择客户时已赋值
        //** 地址信息---------*/
        cusOrderCode: "", //客户单号
        orderId: "", //订单号ID （编辑使用）
        sizeAreaId: "", //号型大类id （亚码 欧码）
        sizeCategoryId: "", //尺寸分类id（净体成衣标准号）
        type: "10", //下单类型 (简单下单，代码下单)
        style: "", //长短款
        memo: "", //订单备注
        remark: "", //备注
        orderInfo: "",
      },
      noChangeEdit: false,
      noChange: false,
      // 特体参数

      specBodyParams: {
        sizeType: "",
        category: "",//需要当前的品类id
        customerId: "",
      },
      standardChoose: {
        property: "", //finished||size  size需要传当前加减值
        id: "", //选择的尺码类型  欧码 亚码
        sizeId: "",
      },
      // 选择的特体图片
      chooseStyleMsg: {
        chooseStyleImg: "",
        chooseStyleContent: "",
      },
      // 尺码类型
      standardList: [],
      // 特体信息（需加入json中编辑使用）
      styleList: [],
      //着装风格 （需加入json中编辑使用）
      clothing: [],
      categroyMsg: "", //工艺信息
      productId: '',
      preSubmitShow:''
    }
  },
  components: {
    rMeasurements,
    rDressStyle
  },
  watch: {
    // 监听单位
    "customerDetails.heightUnit": {
      handler(newval, oldval) {
        if (oldval && newval != oldval) {
          // console.log("转", newval, oldval);
          if (newval == 10266) {
            //英寸转厘米
            if (this.specBodyParams.sizeType == 10054) {
              this.cmsAll();
            } else {
              this.cms();
            }
          } else if (newval == 10265) {
            //厘米转英寸
            if (this.specBodyParams.sizeType == 10054) {
              this.inchsAll();
            } else {
              this.inchs();
            }
          }
        }
      },
      immediate: true,
      deep: true,
    },
    step: {
      handler(newval) {
        if (newval == 3) {
          console.log('step111111111:', this.productMsg)

          this.clothing = []
          this.clothing = this.productMsg
          // this.clothing.push({
          //     id: 2000,
          //     enName: '西裤',
          //     name: '西裤',
          //     // styleId: "",
          //     chooseStyleId: "",
          //     sizeList: [],
          //     standardList: [],
          //     styleList: [],
          // });
          this.getStyleInfo();
          this.listDictSystem();
        }
      },
      deep: true,
      immediate: true

    }
  },
  props: {
    step: Number,
    productMsg: [Object, Array]
  },
  mounted() {
    this.getUnit()
  },
  methods: {
    ...mapActions([
      'getDictSystemAction',
      'getCustAction',
      'listDictSystemAction',
      'styleSpecBodyAction', //特体信息
      'styleAuthInfoAction',
      'styleMeasureInfoAction',
      'styleStandardAction',
      'getFinishedSizeAction',
      'saveOrderAction',
      'submitOrderAction'
    ]),
    setGenderId(e){
      this.submitOrder.genderId = e.gender
    },
    // 第一步校验
    stepOneCheck() {
      console.log(360, this.submitOrder)
      // 校验客户信息
      if (this.submitOrder.customerName == "") {
        this.$Message.error(this.$t("quickorder.qcName"));
        return false;
      } else if (this.submitOrder.height == "") {
        this.$Message.error(this.$t("quickorder.qcHeight"));
        return false;
      }
      // if (this.submitOrder.weight == '') {
      //   this.$Message.error(this.$t("quickorder.qcWeight"));
      //   return false
      // }
      if (this.submitOrder.weightUnit == "") {
        this.$Message.error(this.$t("quickorder.qcWeightUnit"));
        return false;
      }
      if (this.submitOrder.genderId == "") {
        this.$Message.error(this.$t("quickorder.qcGender"));
        return false;
      }
      return true;
    },
    setCategroyMsg(e) {
      this.categroyMsg = e.styleInfoList
      this.extend = e.sizeType
      this.specBodyParams.category = e.clothCategory
      this.productId = e.clothCategory
      this.submitOrder.styleBasicId = e.id
      this.submitOrder.fabric = e.model
      this.preSubmitShow = e.preSubmit
      //设置号型
      this.standard(e.id);
      // console.log('设置信息',e,this.categroyMsg)
    },
    setOrderInfo(orderInfo, editMsg) {
      // this.$set(this, "fabricList", orderInfo.fabricList);
      console.log('orderInfo', orderInfo)
      this.$set(this, "categroyMsg", orderInfo.categroyMsg);
      this.$set(this, "params", orderInfo.params);
      this.$set(this, "standardChoose", orderInfo.standardChoose);
      this.$set(this, "styleList", orderInfo.styleList);
      this.$set(this, "clothing", orderInfo.clothing);
      this.$set(this, "isAddShow", orderInfo.isAddShow);
      this.$set(this, "specBodyParams", orderInfo.specBodyParams);
      this.customerDetails = {
        heightUnitName: editMsg.heightUnitName,
        heightUnit: editMsg.heightUnit,
      };
      // this.$set(this, "basicList", orderInfo.basicList);
      this.customerDetails.heightUnit = editMsg.heightUnit;
      this.submitOrder = editMsg;
      this.submitOrder.onlySize = 1;
    },
    handleScroll(event) {
      if (event.target.scrollTop > 25) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    // 尺码类型
    standard(id) {
      this.styleStandardAction({
        styleBasicId: id
      }).then((res) => {
        this.standardList = res.data;
      });
    },
    // 编辑使用
    changeEditOnce() {
      this.editOnce = false;
    },
    preSubmit() {
      this.submit("size");
    },
    //**  特体信息赋值
    setSpecialBody() {
      this.submitOrder.bodyTypeList = [];
      this.styleList.map((item) => {
        if (item.chooseId) {
          this.submitOrder.bodyTypeList.push(item.chooseId);
        }
      });
    },
    //**  尺寸赋值
    setSize(cloItem, detailsMsg, type) {
      let pass = true;
      for (let i = 0; i < cloItem.sizeList.length; i++) {
        if (
          !cloItem.sizeList[i].disabled &&
          cloItem.sizeList[i].isMust == 1 &&
          (cloItem.sizeList[i].inputValue == "" ||
            !cloItem.sizeList[i].inputValue)
        ) {
          this.$Message.error(
            cloItem.sizeList[i].name + " " + this.$t("newOrder.cannotEmpty")
          );
          pass = false;
          return false;
        } else if (
          !cloItem.sizeList[i].disabled &&
          cloItem.sizeList[i].inputValue &&
          (cloItem.sizeList[i].inputValue > cloItem.sizeList[i].maxValue ||
            cloItem.sizeList[i].inputValue < cloItem.sizeList[i].minValue)
        ) {
          this.$Message.error(
            cloItem.sizeList[i].name + " " + this.$t("newOrder.scope")
          );
          pass = false;
          return false;
        }
      }

      if (pass == false) {
        return;
      }
      detailsMsg.shape = "";
      detailsMsg.sizeList = [];
      detailsMsg.styleId = "";
      if (this.submitOrder.sizeCategoryId === 10054) {
        // 标准号设置号型
        detailsMsg.shape = cloItem.chosoeId;
      } else if (this.submitOrder.sizeCategoryId === 10052) {
        // 净体设置着装风格
        detailsMsg.styleId = cloItem.chooseStyleId;
      } else {
      }
      cloItem.sizeList.map((sizeItem) => {
        if (sizeItem.disabled) return false;
        if (
          this.submitOrder.sizeCategoryId === 10052 &&
          sizeItem.finishId &&
          type != "size"
        ) {
          detailsMsg.sizeList.push({
            partValue: sizeItem.finishValue,
            partId: sizeItem.finishId,
            // modifyValue:
            //   this.standardChoose == "size"
            //     ? sizeItem.inputValue - sizeItem.defaultValue
            //     : "",
          });
        }
        detailsMsg.sizeList.push({
          partValue: sizeItem.inputValue,
          partId: sizeItem.id,
          modifyValue:
            this.standardChoose == "size"
              ? sizeItem.inputValue - sizeItem.defaultValue
              : "",
        });
      });
      return pass;
    },
    // 提交
    submit(type) {
      // this.$router.push("./successfully");

      this.submitOrder.clothCategory = this.productId;
      this.submitOrder.detailList = []; //分步工艺置空
      this.categroyMsg.map((cateItem, cateIndex) => {
        // 循环当前工艺
        this.submitOrder.detailList.push(
          JSON.parse(JSON.stringify(this.detailList))
        );
        let detailsMsg = this.submitOrder.detailList[cateIndex];
        //**  赋值当前品类id
        detailsMsg.clothCategory = cateItem.clothCategory;
        detailsMsg.styleInfoId = cateItem.id;
        console.log(505, detailsMsg)
        cateItem.styleCraftList.map(o => {
          detailsMsg.craftList.push({
            craftId: o.id,
            content: o.type == 1 ? '' : o.model
          })
        })
        // detailsMsg.craftList.map((craftItem, craftInde)=>{

        // })
        //**  赋值当前选中的的工艺信息
        // cateItem.craftList.map((craftItem, craftIndex) => {
        //   // 如果当前工艺如果不是撞色跟刺绣 循环
        //   if (craftItem.category == 1 || craftItem.category == 3) {
        //     // detailsMsg.craftMap.description
        //     this.setCraftMap(craftItem.children, detailsMsg);
        //   }
        // });
        // 工艺
        // this.setCraftMap(cateItem.craft, detailsMsg);
        // 辅料
        // this.setFlMap(cateItem.accessories, detailsMsg);
        // if (cateItem.colorContrast && cateItem.colorContrast.length > 0) {
        //     //如果是撞色
        //     cateItem.colorContrast.map((contrastItem) => {
        //         this.setColorContrast(contrastItem, detailsMsg);
        //     });
        // }
        //**赋值选中的刺绣 */
        // this.setEmbs(cateItem, detailsMsg);
      });

      let customerPass = true;
      //如果赋值成功
      if (customerPass) {
        //**客户单号赋值 */
        // this.submitOrder.cusOrderCode = this.params.orderMsg.inputValue;
        //**尺寸分类赋值*/
        this.submitOrder.sizeCategoryId = this.specBodyParams.sizeType;
        //**赋值特体信息 */
        this.setSpecialBody();
        if (this.submitOrder.sizeCategoryId === 10054) {
          //标准号 选职责号型大类
          this.submitOrder.sizeAreaId = this.standardChoose.id;
        } else {
          this.submitOrder.sizeAreaId = "";
        }
        //**  尺寸赋值
        let passSize = true;
        for (let i = 0; i < this.clothing.length; i++) {
          let detailsMsg = this.submitOrder.detailList[i];
          console.log('detailsMsg', detailsMsg, this.categroyMsg)
          passSize = this.setSize(this.clothing[i], detailsMsg, type);
          if (passSize == false) {
            break;
          }
        }
        console.log('submitOrder', this.submitOrder)
        // return
        if (passSize) {
          if (
            this.$route.query.orderId &&
            this.$route.query.orderType !== "buyagain"
          ) {
            this.submitOrder.orderId = this.$route.query.orderId;
          }

          // let custInfo = {
          //   basicList: this.basicList,
          // };
          // this.submitOrder.custInfo = JSON.stringify(custInfo);
          let orderInfo = {
            fabricList: this.fabricList,
            categroyMsg: this.categroyMsg,
            params: this.params,
            standardChoose: this.standardChoose,
            styleList: this.styleList,
            clothing: this.clothing,
            isAddShow: this.isAddShow,
            basicList: this.basicList,
            specBodyParams: this.specBodyParams,
          };
          this.submitOrder.orderInfo = JSON.stringify(orderInfo);
          this.spinShow = true;
          // return
          if (type == "size") {
            //如果只是为了号型
            this.submitPre();
          } else if (type == "order") {
            if (
              this.isPreSubmit == false &&
              this.submitOrder.sizeCategoryId === 10052
            ) {
              this.submitPre().then(() => {
                this.submitOrderFun();
              });
            } else {
              this.submitOrderFun();
            }
          } else {
            //提交订单
            this.submitCart()
          }
        }
      }
    },
    // 预提交
    async submitPre() {
      await this.getFinishedSizeAction(this.submitOrder)
        .then((res) => {
          if (res.code === 0) {
            for (let key in res.data) {
              let item = this.clothing.find((item) => item.id == key);
              item.sizeList.map((s) => {
                let size = res.data[key].find((i) => i.refPartId == s.id);
                if (undefined !== size) {
                  this.$set(s, "finishValue", size.partValue);
                  this.$set(s, "finishId", size.partId);
                }
              });
            }
            this.isPreSubmit = true;
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 提交购物车
    submitCart() {
      this.saveOrderAction(this.submitOrder)
        .then((res) => {
          // cons.log("是否保存成功", res);
          if (res.code == 0) {
            this.$Message.success(res.message);
            if (
              this.$route.query.orderType &&
              this.$route.query.orderType === "pending"
            ) {
              this.$router.push("./myOrder");
            } else {
              this.$router.push("./saveItems");
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 获取接口返回数据中有用的部分
    handleGetReturnDatat(data) {
      let returnData = {};
      Object.keys(data).map((key) => {
        returnData = data[key];
      });
      return returnData;
    },
    // 提交购物车
    submitOrderFun() {
      this.submitOrderAction(this.submitOrder)
        .then((res) => {
          // cons.log("是否保存成功", res);
          if (res.code == "0") {
            let returnData = this.handleGetReturnDatat(res.data);
            this.$Message.success(res.message);
            if (returnData.sign && returnData.sign === "fail") {
              this.$router.push("/myOrder");
            } else {
              this.$router.push("/underProduction");
            }
          } else {
            this.$Message.error(res.message);
          }
        })
        .finally((res) => {
          this.spinShow = false;
        });
    },
    // 选号型
    changeSizeId(e) {
      this.standardChoose = e;
      this.measureInfo(this.standardChoose.sizeId);
    },
    // 选尺码类型
    changeStandard(e) {
      this.standardChoose = e;
    },
    // 修改特体
    changeStyle(item, litem) {
      item.chooseId = litem.id;
      this.chooseStyleMsg.chooseStyleImg = litem.imagePath;
      this.chooseStyleMsg.chooseStyleContent = litem.description;
    },
    getStyleInfo() {
      this.styleAuthInfoAction({
        category: this.specBodyParams.category,
        styleBasicId:this.submitOrder.styleBasicId
      }).then((res) => {
        // console.log('res.dat',res.data)
        if (!this.$route.query.orderId) {
          if(res.data&&res.data.length>0){
            res.data.map((item) => {
              this.clothing.map((citem) => {
                if (citem.chooseStyleId == "") {
                  citem.chooseStyleId = item.styleList[0].id;
                }
                if (item.id == citem.id) {
                  citem.styleList = item.styleList;
                }
              });
            });
          }
        }
        // this.clothing = res.data
      });
    },
    // 获得量体方式
    listDictSystem() {
      if (this.tailoredList.length == 0) {
        this.listDictSystemAction({
          category: 13,
          extend: this.extend
        }).then((res) => {
          this.tailoredList = res.data;
          if (!this.$route.query.orderId) {
            this.specBodyParams.sizeType = res.data[0].id;
            this.changeTailored(this.specBodyParams.sizeType);
          }
        });
      }
    },
    //修改量体方式
    changeTailored(e) {
      // console.log("e", e);
      if (e === 10052 || e === 10053) {
        this.measureInfo("");
        this.specBody(); //特体信息
      } else {
        this.clothing.map((citem) => {
          citem.sizeList = [];
          citem.chosoeId = ''
          // citem.standardList = []
        });
      }
      this.specBodyParams.sizeType = e;
      console.log("this.standardList", this.standardList);
      if (this.standardList && this.standardList.length > 0) {
        this.standardChoose.id = this.standardList[0].id;
        this.standardChoose.property = this.standardList[0].property;
      }
    },
    // 特体信息
    specBody() {

      this.styleSpecBodyAction(
        {
          sizeType: this.specBodyParams.sizeType,
          styleBasicId: this.submitOrder.styleBasicId,
          customerId: this.specBodyParams.customerId
        }
      ).then((res) => {
        if (res.data) {
          res.data.map((item) => {
            item.chooseId = "";
          });
          this.styleList = res.data;
          this.styleList.map((item) => {
            if (item.chooseId) return false;
            let normalItem = item.details.find(
              (dItem, dIIndex) => dIIndex === 0
            );
            this.$set(item, "chooseId", normalItem.id);
          });
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        } else {
          this.styleList = [];
          this.chooseStyleMsg = {
            chooseStyleImg: "",
            chooseStyleContent: "",
          };
        }
      });
    },
    // 选号型
    measureInfo(shapeCategory) {
      // console.log(123)
      this.shapeCategory = shapeCategory;
      this.styleMeasureInfoAction({
        // category: this.productId || 2000,
        styleBasicId: this.submitOrder.styleBasicId,
        measureType: this.specBodyParams.sizeType,
        shapeCategory: shapeCategory,
        customerId:
          this.specBodyParams.sizeType === 10054
            ? ""
            : this.submitOrder.customerId,
      }).then((res) => {
        console.log(JSON.parse(JSON.stringify(this.clothing)),JSON.parse(JSON.stringify(res.data)))
        res.data.map((item) => {
          this.clothing.map((citem) => {
            if (item.id == citem.id) {
              if (this.specBodyParams.sizeType == 10054) {
                // console.log("this.queryOrderId", this.queryOrderId);
                // if (!this.$route.query.orderId) {
                // 标准号赋值判断条件修改
                if(!citem.chosoeId){
                    citem.standardList = item.sizeList;
                    citem.sizeList = item.sizeList[0].details;
                    citem.chosoeId = item.sizeList[0].id;
                }
                // }
                // this.queryOrderId = "";
                item.sizeList.map((aitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    aitem.details.map((ditem) => {
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  } else {
                    aitem.details.map((ditem) => {
                      ditem.minValue = Number(
                        cmToInch(ditem.minValue).toFixed(2)
                      );
                      ditem.maxValue = Number(
                        cmToInch(ditem.maxValue).toFixed(2)
                      );
                      if (ditem.defaultValue != undefined) {
                        ditem.defaultValue = cmToInch(
                          ditem.defaultValue
                        ).toFixed(2);
                      }
                      ditem.inputValue = JSON.parse(
                        JSON.stringify(ditem.defaultValue)
                      );
                      ditem.addNum = 0.5;
                    });
                  }
                });
              } else {
                citem.standardList = [];
                // 尺寸换算
                item.sizeList.map((sitem) => {
                  if (this.customerDetails.heightUnit == 10266) {
                    // 单位是厘米
                    if (item.sizeUnit === 10266) {
                      sitem.inputValue = sitem.inputValue;
                    } else {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = inchToCom(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                    // 单位是英寸
                  } else {
                    sitem.minValue = Number(
                      cmToInch(sitem.minValue).toFixed(2)
                    );
                    sitem.maxValue = Number(
                      cmToInch(sitem.maxValue).toFixed(2)
                    );

                    if (item.sizeUnit === 10266) {
                      if (sitem.inputValue != undefined) {
                        sitem.inputValue = cmToInch(sitem.inputValue).toFixed(
                          2
                        );
                      }
                    }
                  }
                });
                citem.sizeList = item.sizeList;
              }
            }
          });
        });
        this.handleHasExtension();
        if (this.specBodyParams.sizeType == 10052) {
          // this.preSubmit()
          this.isPreSubmit = false;
        }
      });
    },
    handleChildExtension(children, middleObj) {
      children.map((item) => {
        if (item.children && item.children.length > 0) {
          this.handleChildExtension(item.children, middleObj);
        } else {
          if (item.isDefault === 1 && item.extension) {
            middleObj.hasxtension = true;
            this.handleReviseSzieList(item);
          }
        }
      });
    },
    handleResetDisabled() {
      if (this.specBodyParams.sizeType !== 10054) {
        this.clothing.map((item) => {
          item.sizeList.map((sitem) => {
            this.$set(sitem, "disabled", false);
          });
        });
      } else {
        this.clothing.map((item) => {
          item.standardList.map((sitem) => {
            sitem.details.map((ditem) => {
              this.$set(ditem, "disabled", false);
            });
          });
        });
      }
    },
    handleHasExtension() {
      let middleObj = {
        hasxtension: false,
      };
      console.log('this.categroyMsg', this.categroyMsg)
      // if (this.categroyMsg && this.categroyMsg.length > 0) {

      //     this.categroyMsg.map((item) => {
      //         item.craftList.map((citem) => {
      //             if (citem.children && citem.children.length > 0) {
      //                 this.handleChildExtension(citem.children, middleObj);
      //             }
      //         });
      //     });
      //     if (!middleObj.hasxtension) {
      //         this.categroyMsg.map((item) => {
      //             item.craftList.map((citem) => {
      //                 if (citem.children && citem.children.length > 0) {
      //                     this.handleResetDisabled();
      //                 }
      //             });
      //         });
      //     }
      // }
    },
    next() {
      console.log('this.step', this.step)
      if (this.step == 2 && this.stepOneCheck() == false) {
        //第一步校验
        return;
      }
      this.$emit('next')
    },
    // 英寸转厘面
    cms() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  inchToCom(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    // 英寸转厘面
    cmsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.inputValue = Number(inchToCom(sitem.inputValue).toFixed(2));
              sitem.defaultValue = Number(
                inchToCom(sitem.defaultValue).toFixed(2)
              );
              sitem.minValue = Number(inchToCom(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(inchToCom(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchsAll() {
      if (!this.nochangeBzh) {
        this.clothing.map((aitem) => {
          aitem.standardList.map((item) => {
            item.details.map((sitem) => {
              sitem.defaultValue = Number(
                cmToInch(sitem.defaultValue).toFixed(2)
              );
              sitem.inputValue = Number(cmToInch(sitem.inputValue).toFixed(2));
              sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
              sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
            });
          });
          this.$forceUpdate();
        });
      }
      this.nochangeBzh = false;
    },
    // 厘米转英寸
    inchs() {
      this.clothing.map((item) => {
        item.sizeList.map((sitem) => {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10053
          ) {
            //如果是净体
            if (!this.noChange) {
              if (sitem.inputValue) {
                sitem.inputValue = Number(
                  cmToInch(sitem.inputValue).toFixed(2)
                );
              }
            } else {
              if (sitem.inputValue) {
                sitem.inputValue = sitem.inputValue;
              }
            }
          }
          if (!this.noChangeEdit) {
            sitem.minValue = Number(cmToInch(sitem.minValue).toFixed(2));
            sitem.maxValue = Number(cmToInch(sitem.maxValue).toFixed(2));
          }
        });
      });
      this.noChange = false;
      this.noChangeEdit = false;
    },
    back() {
      this.$emit('back')
    },
    // 修改身高
    changeHeight(item) {
      this.customerDetails.heightUnitName = item.label;
      this.customerDetails.heightUnit = item.value;
    },
    // 获取单位
    getUnit() {
      this.getDictSystemAction({
        category: 10, //性别
      }).then((res) => {
        // console.log('res',res)
        this.genderList = res.data;
        
      });
      this.getDictSystemAction({
        category: 29, //体重
      }).then((res) => {
        this.weightList = res.data;
        if (!this.$route.query.orderId) {
          this.submitOrder.weightUnit = res.data[0].id;
        }
      });
      this.getDictSystemAction({
        category: 30, //身高
      }).then((res) => {
        res.data.map((item) => {
          if (item.id == 10266) {
            if (this.$route.query.orderId == undefined) {
              this.customerDetails = {
                heightUnitName: item.name,
                heightUnit: item.id,
              };
              this.submitOrder.heightUnit = item.id;
            }
          }
        });
        // console.log("this.customerDetails", this.customerDetails);
        this.heightList = res.data;
      });
    },
    handleSearch(e) {
      this.getCustAction({keywords: e}).then((res) => {
        this.customer = res.data;
      });
    },
    changeCus(e) {
      this.customer.map((item) => {
        if (e == item.custName) {
          this.chooseCustomer(item);
        }
      });
    },
    // 选择客户
    chooseCustomer(e) {
      this.bodyList = e.customerSizeList;
      this.cySizeList = e.cySizeList;
      // this.bodyList = custInfo.bodyList;
      if (e.customerSpecialList.length > 0) {
        this.styleList.map((item) => {
          e.customerSpecialList.map((citem) => {
            if (citem.desId == item.id) {
              item.chooseId = citem.specId;
            }
          });
        });
      } else {
        this.styleList.map((item) => {
          item.chooseId = item.details[0].id;
        });
      }
      if (
        this.specBodyParams.sizeType == 10053 &&
        this.cySizeList &&
        this.cySizeList.length > 0
      ) {
        this.clothing.map((item) => {
          this.cySizeList.map((cyitem) => {
            if (item.id == cyitem.clothId) {
              item.sizeList.map((sitem) => {
                this.$set(sitem, "inputValue", "");
                cyitem.partList.map((cypitem) => {
                  if (cypitem.partId == sitem.id) {
                    if (cypitem.partSize) {
                      this.$set(sitem, "inputValue", cypitem.partSize);
                    }
                    // if (this.customerDetails.heightUnit == 10266) {
                    // } else {
                    //   if (cypitem.partSize) {
                    //     sitem.inputValue = cmToInch(cypitem.partSize).toFixed(
                    //       2
                    //     );
                    //   } else {
                    //     sitem.inputValue = "";
                    //   }
                    // }
                    // sitem.inputValue = cypitem.partSize
                  }
                });
              });
            }
          });
        });
      } else {
        if (this.specBodyParams.sizeType !== 10054) {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              this.$set(sitem, "inputValue", "");
            });
          });
        }
      }

      if (this.specBodyParams.sizeType != 10054) {
        if (e.customerSizeList.length > 0) {
          if (
            this.specBodyParams.sizeType == 10052 ||
            this.specBodyParams.sizeType == 10054
          ) {
            this.clothing.map((item) => {
              item.sizeList.map((sitem) => {
                this.$set(sitem, "inputValue", "");
                this.bodyList.map((bitem) => {
                  if (bitem.partId == sitem.id && bitem.partSize) {
                    sitem.inputValue = bitem.partSize;
                  }
                });
              });
            });
          }
        } else {
          this.clothing.map((item) => {
            item.sizeList.map((sitem) => {
              sitem.inputValue = "";
            });
          });
        }
      }

      this.submitOrder.customerId = e.id;
      this.submitOrder.customerName = e.custName;
      this.submitOrder.genderId = e.genderId;
      this.submitOrder.height = e.height;
      this.submitOrder.heightUnit = e.heightUnit;
      this.submitOrder.weight = e.weight;
      this.submitOrder.weightUnit = e.weightUnit;
      this.submitOrder.phone = e.phone;
      this.submitOrder.email = e.email;
      this.customerDetails = e;
      this.changeCusNum++;
      if (
        this.changeCusNum == 1 &&
        e.heightUnit == 10266 &&
        this.specBodyParams.sizeType != 10053
      ) {
        this.noChange = false;
      } else {
        this.noChange = true;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.choose-cus-btn {
  position: fixed;
  bottom: 20px;

  > div {
    width: 116px;
    height: 40px;
    margin-left: 14px;
    line-height: 40px;
    text-align: center;
    background: rgba(8, 25, 56, .3);
    color: #fff;
    cursor: pointer;
  }

  .btn-next {
    background-color: #0A4DCC;
  }
}

.choose-cus {
  max-width: 1440px;
  background: #fff;
  padding: 20px 20px 10px 20px;
  margin: 0 auto;
}

.quick-order-details {
  width: 1420px;
  margin: 10px auto 0;
  background: #fff;
  padding: 10px 40px 10px;
  text-align: left;
  position: relative;

  .quick-order-l-box {
    width: 430px;
    background: #fff;
  }

  .quick-order-l {
    width: 420px;
    position: sticky;
  }

  .quick-order-r {
    flex: 1;
    padding-left: 40px;

    .order-r-optional {
      font-size: 16px;
      font-weight: 500;
      color: #081938;
      line-height: 19px;
    }

    .order-r-box {
      margin-bottom: 20px;
    }

    .order-r-title {
      margin-right: 24px;
      width: 60px;
    }

    .order-r-ipt {
      width: 350px;
    }

    .order-r-textarea {
      /deep/ .ivu-input {
        background-color: #f8f8f8;
      }
    }

    .craft-item-box {
      margin-right: 17px;
      margin-bottom: 10px;
    }

    .craft-item-box-small {
      margin-right: 30px;
      margin-bottom: 10px;
    }

    .craft-item {
      .craft-item-i-box {
        width: 156px;
        height: 156px;
        border-radius: 2px;
        border: 2px solid #fff;
        background: #f8f8f8;

        .craft-item-i-box-big {
          width: 152px;
          height: 152px;
        }
      }

      .craft-item-name {
        font-size: 12px;
        font-weight: 400;
        color: #081938;
        line-height: 14px;
        text-align: center;
        margin-top: 10px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        width: 100px;
      }

      .craft-item-select {
        border: 2px solid #003888;
        position: relative;

        .craft-item-price {
          width: 151px;
          height: 18px;
          line-height: 18px;
          background: #0a4dcc;
          border-radius: 2px;
          position: absolute;
          left: 0;
          right: 0;
          margin-right: auto;
          margin-left: auto;
          bottom: 2px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .craft-item-i-box {
      width: 156px;
      height: 156px;
      border-radius: 2px;
      border: 2px solid #fff;
      background: #f8f8f8;

      .craft-item-i-box-big {
        width: 152px;
        height: 152px;
      }
    }

    .craft-item-name {
      font-size: 12px;
      font-weight: 400;
      color: #081938;
      line-height: 14px;
      text-align: center;
      margin-top: 10px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
      width: 100px;
    }

    .craft-item-select {
      border: 2px solid #003888;
      position: relative;

      .craft-item-price {
        width: 151px;
        height: 18px;
        line-height: 18px;
        background: #0a4dcc;
        border-radius: 2px;
        position: absolute;
        left: 0;
        right: 0;
        margin-right: auto;
        margin-left: auto;
        bottom: 2px;
        text-align: center;
        color: #fff;
        font-size: 12px;
      }
    }

    .craft-optional {
      font-size: 14px;
      font-family: ArialMT;
      color: #081938;
      line-height: 16px;
      margin-bottom: 15px;
    }

    .craft-item-btns {
      padding-bottom: 20px;
      margin-bottom: 20px;
    }

    .craft-set-price {
      width: 300px;
      height: 40px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid rgba(8, 25, 56, 0.1);
      padding: 0 7px;
      margin-bottom: 20px;

      /deep/ .ivu-input {
        border: none;
        box-shadow: none;
      }

      .craft-price {
        width: 74px;
        height: 22px;
        background: #0a4dcc;
        border-radius: 2px;
        font-size: 12px;
        font-weight: 400;
        color: #ffffff;
        line-height: 22px;
        text-align: center;
      }
    }

    .craft-item-small {
      .craft-item-i-box {
        width: 100px;
        height: 100px;
        border-radius: 2px;
        border: 2px solid #fff;
        background: #fff;

        img {
          display: block;
          margin: 0 auto;
          max-width: 96px;
          object-fit: cover;
        }
      }

      .craft-item-name {
        font-size: 12px;
        font-weight: 400;
        color: #081938;
        line-height: 14px;
        text-align: center;
        margin-top: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        width: 100px;
      }

      .craft-item-select {
        border: 2px solid #003888;
        position: relative;
        overflow: hidden;

        .craft-item-price {
          width: 94px;
          height: 18px;
          line-height: 18px;
          background: #0a4dcc;
          border-radius: 2px;
          position: absolute;
          left: 0;
          right: 0;
          margin-right: auto;
          margin-left: auto;
          bottom: 2px;
          text-align: center;
          color: #fff;
          font-size: 12px;
        }
      }
    }

    .emb-title {
      font-size: 14px;
      color: #081938;
      line-height: 16px;
      margin-bottom: 20px;
    }

    .emb-item {
      margin-right: 40px;
    }

    .md-add {
      width: 40px;
      height: 40px;
      background: #0a4dcc;
      border-radius: 4px;
      color: #fff;
      font-weight: bold;
      margin-left: 40px;
      padding: 0;
      text-align: center;
      line-height: 40px;
    }
  }
}

.quick-order-ll-box {
  // width: 450px;
  height: calc(100vh - 104px);
  background: #fff;
}

.order-l-item {
  width: 420px;
  background: #f8f8f8;
  margin: 5px 0;
  padding: 12px 30px;

  .order-l-item-label {
    font-size: 14px;
    font-weight: 400;
    color: #081938;
    line-height: 16px;
    width: 70px;
    padding-right: 10px;
    text-align: left;
    position: relative;
  }

  .order-l-item-label-icon {
    position: absolute;
    left: -20px;
    font-size: 16px;
    cursor: pointer;
    top: 0;
    bottom: 0;
    margin-top: auto;
    margin-bottom: auto;
  }


  /deep/ .ivu-select-selection {
    border: none;
    background-color: #f8f8f8 !important;
  }

  .order-l-item-ipt {
    background-color: #f8f8f8 !important;
    width: 200px;

    /deep/ .ivu-input {
      border: none;
      box-shadow: none;
      background-color: #f8f8f8 !important;
    }
  }

  .order-l-item-craft {
    width: 120px;
    margin-right: 20px;
  }

  .order-l-item-select {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: #081938;
    line-height: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/styleOrdering/chooseCustomer.vue